import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // includes Popper

// Expose the ESM API to window so you can use it in DevTools:
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

import ui from "./store/modules/ui";

if (!store.hasModule("ui")) {
  store.registerModule("ui", ui);
}

// Optional global configuration for Toast
const options = {
  position: "bottom-left",
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
};

import jQuery from "jquery";
const $ = jQuery;
window.$ = $;

const app = createApp(App);

app.use(router);
app.use(store);
app.use(Toast, options);

app.mount("#app");
